module.exports = __webpack_public_path__ + "img/people-45-min.5c4e3de1.png";